var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyst(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_659)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9375 1.57529L17.3125 5.95029C17.4375 6.07529 17.5 6.20029 17.5 6.38779V17.6378C17.5 18.3253 16.9375 18.8878 16.25 18.8878H6.25C5.5625 18.8878 5 18.3253 5 17.6378V15.1378H3.75C3.0625 15.1378 2.5 14.5753 2.5 13.8878V10.1378C2.5 9.45029 3.0625 8.88779 3.75 8.88779H5V2.63779C5 1.95029 5.5625 1.38779 6.25 1.38779H12.5C12.6875 1.38779 12.8125 1.45029 12.9375 1.57529ZM16 6.38779L12.5 2.88779V6.38779H16ZM9.75 10.1378H3.75V13.8878H9.75625L11.875 12.0128L9.75 10.1378ZM6.25 17.6378H16.25V7.63779H12.5C11.8125 7.63779 11.25 7.07529 11.25 6.38779V2.63779H6.25V8.88779H9.75625C10.05 8.88779 10.3438 8.99404 10.5688 9.18779L12.6937 11.069C12.9625 11.3003 13.1187 11.644 13.1187 12.0128C13.1187 12.3815 12.9625 12.7253 12.6875 12.9628L10.575 14.8315C10.3438 15.0315 10.0562 15.1378 9.75625 15.1378H6.25V17.6378ZM10 12.0128C10 12.358 9.72018 12.6378 9.375 12.6378C9.02982 12.6378 8.75 12.358 8.75 12.0128C8.75 11.6676 9.02982 11.3878 9.375 11.3878C9.72018 11.3878 10 11.6676 10 12.0128Z",
    fill: "url(#paint0_linear_109_659)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_659",
    x1: 2.5,
    y1: 1.68961,
    x2: 17.5,
    y2: 19.1896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F67E7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA6A6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.137787)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyst);
export default __webpack_public_path__ + "static/media/analyst.3b3694b0dbe8873ad0cd55e47eeb5e51.svg";
export { ForwardRef as ReactComponent };